// VUE_APP_FF_CAMP_PAGE_PASSWORD
export default {
  usePagePassword: process.env.VUE_APP_FF_PAGE_PASSWORD === 'true',
  useSocialHandles: process.env.VUE_APP_FF_SOCIAL_HANDLES === 'true',
}
